
import { alertActions } from "../../alert.action";
import { emailConstants } from "../../../../constants/email/email.constants";
import { communicationService } from "../../../../services/communication/communication.service";
import { deepClone } from "../../../../helpers/objectHelper";
import { emailWrapperHtml } from "../../../../cms/areas/email/containers/EmailEditor/Wrappers/EmailWrapperHtml";
import { store } from "../../../configureStore";
import { emailHelper } from "../../../../cms/areas/email/helper/email.helper";
import { emailService } from "../../../../services/cms/email/email.service";
import { cmsActions } from "../cms.action";
import { history } from "../../../../helpers/history";
import { toKebabCase } from "../../../../helpers/cssHelper";
import { emailElementType } from "../../../../cms/areas/email/constants/emailElementType.constants";


export const emailActions = {
    updateEmailElement,
    update,
    get,
    deselect,
    select,
    softUpdate,
    remove,
    sendTest,
    getByEvent
};


/* function restore() {
    return dispatch => {
        dispatch(success());
    };
    function success() {
        return { type: pageConstants.RESTORE_PAGE };
    }
} */
function remove(element) {
    return dispatch => {
        dispatch(success(element));
    };
    function success() {
        return { type: emailConstants.REMOVE_EMAIL_ELEMENT, element };
    }
}
function deselect() {
    return dispatch => {
        dispatch(success());
    };
    function success() {
        return { type: emailConstants.DESELECT_EMAIL_ELEMENT };
    }
}
function select(element) {
    return dispatch => {
        dispatch(success(element));
    };
    function success(element) {
        return { type: emailConstants.SELECT_EMAIL_ELEMENT, element };
    }
}
function softUpdate(email) {
    const cms = store.getState().cms;
    return dispatch => {
        if (email.inherit === true && email.eventId != cms.eventId) {
            dispatch(cmsActions.inheritageAffected(true));
        }
        dispatch(success(email));
    };
    function success(email) {
        return { type: emailConstants.SOFT_UPDATE_EMAIL, email };
    }
}

function updateEmailElement(element, id, isSavable = true, inherit = null) {
    const cms = store.getState().cms;
    const email = store.getState().email;
    return dispatch => {
        if (inherit === true && email.eventId != cms.eventId) {
            dispatch(cmsActions.inheritageAffected(true));
        }
        dispatch(success(element, id, isSavable));
    };
    function success(element) {
        return { type: emailConstants.UPDATE_EMAIL_ELEMENT, element, id, isSavable };
    }
}
function update(oldEmail) {
    return dispatch => {
        dispatch(request());
        const newEmail = deepClone(oldEmail);
        const template = store.getState().template;
        let rawBody = '';
        const adjustedElements = newEmail.elements.map(e => {
            if (e.style.elementProps && e.style.elementProps.editor) {
                e.style.elementProps.editor = null;

            }
            if (e.type == 'TEXT') {
                const { text, subtitle, title, tcell, table, thead, a } = template.template.content;
                const textStyle = { text, subtitle, title, tcell, table, thead, a };

                e.content = e.content.replace('[TemplateStyle]', `
                <style>
                ${template.template ? toKebabCase(textStyle, true, false) : ''}
                a, h1, h2,h3,h4,h5,h6 , p, td{
                    font-family: ${e.style.styleProps.fontFamily} !important;
                }
                a {
                    color: ${textStyle.a.color} !important;
                }
                </style>
                `);
                rawBody += '\n';
                rawBody += e.style.elementProps.text;
            }
            if (e.type == emailElementType.BUTTON) {
                rawBody += '\n';
                rawBody += e.style.elementProps.link;
            }

            return e;
        })
        newEmail.elements = adjustedElements;
        newEmail.rawBody = rawBody;
        newEmail.body = emailWrapperHtml(emailHelper.sortElements(newEmail.elements), newEmail.previewText, template.template ? template.template.content : null)
        newEmail.bodyJson = JSON.stringify(newEmail.elements);

        emailService.update(newEmail).then(
            email => {
                email.elements = email.bodyJson ? emailHelper.sortElements(JSON.parse(email.bodyJson), true) : [];
                if (newEmail.comContentId != email.comContentId) {
                    history.push('/cms/email/' + email.comContentId+window.location.search);
                }
                dispatch(success(email));
            },
            error => {
                dispatch(failure(error));
            }
        );
    };

    function request() {
        return { type: emailConstants.UPDATE_EMAIL_REQUEST };
    }
    function success(email) {
        return { type: emailConstants.UPDATE_EMAIL_SUCCESS, email };
    }
    function failure(error) {
        return { type: emailConstants.UPDATE_EMAIL_FAILURE, error };
    }
}
function getByEvent(eventId) {
    return dispatch => {
        dispatch(request());
        dispatch(alertActions.clear());
        emailService.getAll(eventId).then(
            emails => {
                dispatch(success(emails));
            },
            error => {
                dispatch(failure(error));
            }
        );
    };

    function request() {
        return { type: emailConstants.GETALL_EMAIL_REQUEST };
    }
    function success(emails) {
        return { type: emailConstants.GETALL_EMAIL_SUCCESS, emails };
    }
    function failure(error) {
        return { type: emailConstants.GETALL_EMAIL_FAILURE, error };
    }
}
function get(communicationId) {
    return dispatch => {
        dispatch(request());
        dispatch(alertActions.clear());
        emailService.get(communicationId).then(
            email => {
                dispatch(success(email));
            },
            error => {
                dispatch(failure(error));
            }
        );
    };

    function request() {
        return { type: emailConstants.GET_EMAIL_REQUEST };
    }
    function success(email) {
        return { type: emailConstants.GET_EMAIL_SUCCESS, email };
    }
    function failure(error) {
        return { type: emailConstants.GET_EMAIL_FAILURE, error };
    }
}
function sendTest(mail) {
    return dispatch => {
        dispatch(request());
        dispatch(alertActions.clear());
        emailService.sendTest(mail).then(
            email => {
                dispatch(success());
            },
            error => {
                dispatch(failure(error));
            }
        );
    };

    function request() {
        return { type: emailConstants.SEND_TEST_REQUEST };
    }
    function success(email) {
        return { type: emailConstants.SEND_TEST_SUCCESS };
    }
    function failure(error) {
        return { type: emailConstants.SEND_TEST_FAILURE, error };
    }
}

